//相同部分
export var API_KEY = "PfjuEIOoInZZXvyVVakrSinMe";
export var SECRET_KEY = "mfzOmzczDZZOyaQthAePrvdwvRRxFjiF"; //horoscrope

export var BASE_URL = "https://horoscope.bbcget.com";
export var BASE_URL_VISION = "https://vision.bbcget.com";
export var UA = "FaceRead/1.5.13 (iPhone; iOS 12.1.3; Scale/3.00)";
export var PACKAGE_NAME = "com.gm.faceread";
export var HORO_TODAY_PATH = "/api/v1/forecast/today";
export var HORO_TOMORROW_PATH = "/api/v1/forecast/today";
export var HORO_WEEK_PATH = "/api/v1/forecast/week";
export var HORO_MONTH_PATH = "/api/v1/forecast/month";
export var HORO_YEAR_PATH = "/api/v1/forecast/year";
export var HORO_PERSON_FUTURE_PATH = "/api/horoscope/v1/face/personality_future_report"; //pd新

export var NEW_BASE_URL = "http://horoscope.palmdecoder.com";
export var NEW_BASE_URL_VISION = "http://vision.palmdecoder.com";
export var NEW_UA = "Palmistry/1.2.2 (iPhone; iOS 12.1.3; Scale/3.00)";
export var NEW_PACKAGE_NAME = "com.gm.faceread";
export var LOVA_REPORT_PATH = "/api/horoscope/v1/report/love_report";
export var PALM_COMPATIBILITY_PATH = "/api/v1/compatibility/palm";
export var WEALTH_REPORT_PATH = "/api/horoscope/v1/report/wealth_report";